import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericLoaderData } from '../../models/generic-loader.model';

@Component({
    selector: 'claims-generic-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './generic-loader.component.html',
    styleUrls: ['./generic-loader.component.scss']
})
export class GenericLoaderComponent implements OnChanges {
    @Input() public genericLoaderDetail: GenericLoaderData = { showLoader: false, loaderMessage: '' };
    public showLoader = false;
    public loaderMessage = '';

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.['genericLoaderDetail'] && changes['genericLoaderDetail'].currentValue) {
            this.showLoader = !!changes['genericLoaderDetail'].currentValue.showLoader;
            this.loaderMessage = changes['genericLoaderDetail'].currentValue.loaderMessage ?? '';
        } else {
            this.showLoader = false;
            this.loaderMessage = '';
        }
    }
}
